/**
 * Shared TanStack Query client for the web app.
 *
 * Defaults are deliberately conservative so adopting a query changes only
 * the caching behavior, not when data refreshes:
 * - no refetch on window focus (the app never refetched on focus before)
 * - 30s staleTime: repeated mounts within a session (modal reopens,
 *   StrictMode double-fires, sibling components needing the same
 *   reference data) share one fetch instead of issuing a network storm
 * - one retry, never for 4xx (client errors won't succeed on retry)
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (failureCount >= 1) return false;
        const message = error instanceof Error ? error.message : '';
        // The shared ApiClient embeds the status in the message for empty
        // bodies; structured errors won't match — retrying once is harmless.
        if (/HTTP 4\d\d/.test(message)) return false;
        return true;
      },
    },
  },
});
